import {isAddonInvalidError} from '../../helpers/addon-error'
import {shapeParticipantsForRequest} from '../../helpers/addon-lines'
import {API} from '../../networking/http'
import {BookingStateParticipant} from '../../services/booking/forms/types'
import {QueryMethod} from '../helpers/types'
import {CalculatedBookingPriceObject} from './calculate-booking-price'

export type SubscriptionStatus = string

export type LimitationCheckResultType = {
  minutes?: number
  entries?: number
  credits?: number
}
export type LimitationCheckResultTypeKey = keyof LimitationCheckResultType

export type Option = {
  venueId?: string
  userId?: string
  date?: string
  participants: BookingStateParticipant[]
  useForParticipants?: boolean
  start?: number
  areaId?: string
  sportId?: string | null
  teacherId?: string
}

export type CalculateSplitBookingPriceParams = undefined
export type CalculateSplitBookingPriceQueryParams = Option | null
export type CalculateSplitBookingPriceQueryReturnType = CalculatedBookingPriceObject
export type CalculateSplitBookingPriceQuery = QueryMethod<
  CalculateSplitBookingPriceParams,
  CalculateSplitBookingPriceQueryParams | null,
  CalculateSplitBookingPriceQueryReturnType
>

export const calculateSplitBookingPriceEndpoint = 'bookings/calculate/splitBookingPrice'

export const calculateSplitBookingPriceQuery: CalculateSplitBookingPriceQuery = ({query, ...rest}) => ({
  queryKey: ['calculateSplitBookingPriceQuery'],
  cacheTime: 1000 * 5,
  queryFn: () =>
    API.post<CalculateSplitBookingPriceQueryParams | null | undefined, CalculateSplitBookingPriceQueryReturnType>(
      calculateSplitBookingPriceEndpoint,
      query?.participants ? {...query, participants: shapeParticipantsForRequest(query.participants)} : {...query},
    ).then((res) => res.data),
  retry: (failureCount, error) => !isAddonInvalidError(error) && failureCount < 3,
  ...rest,
})
